'use client';

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { getAuth } from 'firebase/auth';
import Swal from 'sweetalert2';

const firebaseConfig = {
  apiKey: "AIzaSyCVqwjx1iNlnSU9uy22p09IhJxwH9sEyzA",
  authDomain: "onetime-storage.firebaseapp.com",
  projectId: "onetime-storage",
  storageBucket: "onetime-storage.firebasestorage.app",
  messagingSenderId: "259986382293",
  appId: "1:259986382293:web:72f15fcc6d4c630316315c",
  measurementId: "G-8169SYTBZS"
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

const messagingInstance = async () => {
  try {
    const isSupportedBrowser = await isSupported();

    // console.log('✅ Firebase Messaging supported:', isSupportedBrowser);
    if (isSupportedBrowser) return getMessaging(app);
    return null;
  } catch (err) {
    console.error('Error checking messaging support:', err);
    return null;
  }
};

const fetchToken = async (
  setTokenFound: (found: boolean) => void,
  setFcmToken: (token: string | null) => void
): Promise<string | null> => {
  const messaging = await messagingInstance();

//   console.log('🔄 Checking Firebase Messaging support:', messaging);

  if (!messaging) {
    console.error('Messaging not supported.');
    setTokenFound(false);
    return null;
  }

  try {
    // Register service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/firebase-cloud-messaging-push-scope/'
    });

    await waitForServiceWorkerActivation(registration);

    const currentToken = await getToken(messaging, {
      vapidKey: "BMjSaXFnDPvHlQEFXLGOojo21cBR_LbnlfLTsWPsQZXg4Qzz8XY0fKeAucP9Fsh0AbOdAWlvkm7PVMlqZbrXUCk", // From Firebase Console -> Project Settings -> Cloud Messaging -> Web Push certificates
      serviceWorkerRegistration: registration
    });

    // console.log('🔑 Token retrieved:', currentToken);

    if (currentToken) {
    //   console.log('✅ FCM Token:', currentToken);
      setTokenFound(true);
      setFcmToken(currentToken);
      
      // Handle foreground messages
      onMessage(messaging, (payload) => {
        // console.log('Message received:', payload);
        // You can display a notification or update UI here
      });
      
      return currentToken;
    } else {
      console.warn('⚠️ No registration token available');
      setTokenFound(false);
      setFcmToken(null);
      return null;
    }
  } catch (err) {
    console.error('Error retrieving token:', err);
    return null;
  }
};

export const requestNotificationPermission = async (
  setTokenFound: (found: boolean) => void, 
  setFcmToken: (token: string | null) => void
) => {
  try {
    if (!('Notification' in window)) {
      console.warn('This browser does not support notifications');
      setTokenFound(false);
      setFcmToken(null);
      return;
    }

    const permission = await Notification.requestPermission();
    // console.log('🔔 Notification permission status:', permission);

    if (permission === 'granted') {
      const fcmToken = await fetchToken(setTokenFound, setFcmToken);
      return fcmToken;
    } else {
      console.warn('Notification permission not granted');
      // alert('You have blocked notifications. Please enable notifications to receive updates.');
      setTokenFound(false);
      setFcmToken(null);
      return null;
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    setTokenFound(false);
    setFcmToken(null);
  }
};

function waitForServiceWorkerActivation(registration: ServiceWorkerRegistration): Promise<ServiceWorker> {
  return new Promise((resolve, reject) => {
    if (registration.active) {
      resolve(registration.active);
    } else if (registration.installing) {
      registration.installing.addEventListener('statechange', (event) => {
        if ((event.target as ServiceWorker).state === 'activated') {
          resolve(registration.active!);
        }
      });
    } else {
      reject(new Error('No active or installing service worker found.'));
    }
  });
}
